import { format } from '@/plugins/moment'
import { mapActions, mapGetters } from 'vuex'
import Title from '@/agilis/components/Title/Title.vue'

export default {
  name: 'PushNotificationPanel',

  components: {
    Title
  },

  data: () => ({
  }),

  mounted: function () {
  },

  computed: {
    ...mapGetters({
      userId: 'userDataStore/userId',
      userIsAdmin: 'userDataStore/userIsAdmin',
      authorizedApplications: 'configurationStore/auth/applications',
      pushMessages: 'notificationStore/pushMessages'
    }),
    computedMessages () {
      return this.pushMessages
    },
    computedTitle () {
      return this.$t('title.pushNotificationPanel')
    },
    showPanel () {
      return this.pushMessagesShow
    },
    computedHeaders () {
      return [
        {
          text: 'subject',
          value: 'subject'
        },
        {
          text: 'actions',
          value: 'actions'
        }
      ]
    },
    computedItems () {
      return this.pushMessages
    },
    computedExpandedItems () {
      return []
    }
  },

  methods: {
    ...mapActions({
      notifyError: 'notificationStore/notifyError',
      removePushMessage: 'notificationStore/removePushMessage',
      removeAllPushMessage: 'notificationStore/removeAllPushMessage'
    }),

    formatCaption (item) {
      const time = format(new Date(item.receptionTime), this.$t('format.dateTime'))
      const applicationName = item.extendedData?.applicationName ? ' - ' + item.extendedData.applicationName : ''
      const workspaceIdI18N = item.extendedData?.workspaceIdI18N ? ' - ' + item.extendedData.workspaceIdI18N : ' - ' + item.extendedData.workspaceId
      return `${time} ${applicationName} ${workspaceIdI18N}`
    },

    formatHeader (timestamp, msgSubject) {
      let html = new Date(timestamp).toLocaleString()
      html += '</br>'
      html += '<b>' + msgSubject + '</b>'
      return html
    },

    formatContent (msgBody) {
      return msgBody.replace(/(?:\r\n|\r|\n)/g, '<br/>')
    },

    deleteAll () {
      this.removeAllPushMessage()
    },

    deleteItem (item) {
      this.removePushMessage(item)
    },

    viewItem (item) {
      this.$router.agilis.viewTracker({
        applicationId: item.extendedData.applicationId,
        trackerTypeId: item.extendedData.trackerTypeId,
        workspaceId: item.extendedData.workspaceId,
        trackerId: item.extendedData.id
      })
    }
  }
}
